import { Icon } from '@types';

/**
 * QLD Design System Arrow right icon
 */
export const ArrowRight = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			width="22"
			height="22"
			viewBox="0 0 22 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.9096 9.71929H1.45579C1.25226 9.71929 1.08375 9.65155 0.95025 9.51608C0.81675 9.3808 0.75 9.21013 0.75 9.00408C0.75 8.79784 0.81675 8.62708 0.95025 8.4918C1.08375 8.35652 1.25226 8.28888 1.45579 8.28888H14.9096L8.67294 1.97668C8.53851 1.83457 8.46932 1.66827 8.46539 1.47777C8.46127 1.28728 8.53242 1.11889 8.67884 0.972603C8.82526 0.826127 8.99087 0.751941 9.17568 0.750043C9.36048 0.747956 9.52609 0.8211 9.67251 0.969473L16.9871 8.38166C17.0787 8.47463 17.1454 8.57149 17.1874 8.67224C17.2291 8.77318 17.25 8.88408 17.25 9.00494C17.25 9.12599 17.2291 9.2366 17.1874 9.33678C17.1454 9.43696 17.0787 9.53354 16.9871 9.62651L9.67251 17.0387C9.53714 17.1759 9.3748 17.2463 9.18551 17.2499C8.99602 17.2535 8.82713 17.1831 8.67884 17.0387C8.53242 16.8882 8.45921 16.7189 8.45921 16.5307C8.45921 16.3425 8.53242 16.1765 8.67884 16.0329L14.9096 9.71929Z"
				fill="#008635"
			/>
		</svg>
	);
};
